





















































import Vue from 'vue';
import Draggable from 'vuedraggable';
import _ from 'lodash';
import store from '@/store';
import { Constants } from "@/api-constants";
import { API } from "aws-amplify";
import { Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import { ViewpointFactorResource } from "@/api/model/ViewpointFactorResource";
import Decision from "@/store/decision/Decision";
import { FactorGroup, FactorResource } from "@/api/model/FactorResource";
import vuetify from "@/plugins/vuetify";

@Component({
  components: {
    'draggable': Draggable,
  }
})
export default class PropertyMenu extends Vue {

  updatingFactors = false
  factorGroupName = 'Lifestyle'
  updateSync: any = null;


  get maxWeight(): number {
    let possibleMax = _.maxBy(this.lifestyleViewpointFactorsList, 'numWeightingDots')
    return possibleMax ? possibleMax.numWeightingDots || 0 : 0
  }

  get viewpointFactors() {
    return getModule(ViewpointsModule).viewpointFactors
  }

  get viewpointFactorsList(): ViewpointFactorResource[] {
    return Object.values(getModule(ViewpointsModule).viewpointFactors)
  }

  get lifestyleViewpointFactorsList() {
    return this.lifestyleFactors.filter(f => this.viewpointFactors[f.id]).map(f => this.viewpointFactors[f.id])
  }

  get factors() {
    return getModule(Decision).factorResourceMap
  }

  get lifestyleFactors() {
    let lifestyleFactorGroup = Object.values(this.factors)
        .find((f: FactorResource) => f.name === this.factorGroupName) as FactorGroup
    if (!lifestyleFactorGroup) return [];
    return lifestyleFactorGroup.childrenIds.map(id => this.factors[id]).filter(f => f)
  }

  get sortedLifestyleFactors() {
    return this.lifestyleFactors
        .filter(f => this.viewpointFactors[f.id] && this.viewpointFactors[f.id].numWeightingDots)
        .sort((a, b) => this.getWeight(b.id) - this.getWeight(a.id))
  }

  get nonSelectedLifestyleFactors() {
    return this.lifestyleFactors.filter(f => !this.viewpointFactors[f.id] || !this.viewpointFactors[f.id].numWeightingDots)
  }

  private getWeight(factorId: string) {
    let vf = this.viewpointFactors[factorId]
    return vf ? vf.numWeightingDots || 0 : 0
  }

  selectFactor(fId: string) {
    //@ts-ignore
    this.lifestyleViewpointFactorsList.filter(vf => vf && vf.numWeightingDots > 0)
        .forEach(vf => Vue.set(vf, 'numWeightingDots', (vf.numWeightingDots || 0) + 1))
    let viewpointFactor = this.viewpointFactors[fId];
    if (!viewpointFactor) {
      viewpointFactor = {
        id: fId,
        viewpointId: getModule(ViewpointsModule).selectedViewpointId,
        numWeightingDots: 1
      }
      Vue.set(this.viewpointFactors, fId, viewpointFactor)
    } else {
      viewpointFactor.numWeightingDots = 1;
    }
    this.reallocateWeights()
    this.initiateSync()
  }

  deselectFactor(fid: number) {
    Vue.set(this.viewpointFactors[fid], 'numWeightingDots', 0);
    this.reallocateWeights();
    this.initiateSync()
  }

  reallocateWeights() {
    this.lifestyleViewpointFactorsList
        //@ts-ignore
        .filter(vf => vf && vf.numWeightingDots > 0)
        //@ts-ignore
        .sort((a, b) => a.numWeightingDots - b.numWeightingDots)
        .forEach((vf, index) => vf.numWeightingDots = index + 1)
  }

  dragStart() {
  }

  dragEnd(event: any) {
    if (event.moved) {
      let newIndex = this.sortedLifestyleFactors.length - event.moved.newIndex;
      let oldIndex = this.sortedLifestyleFactors.length - event.moved.oldIndex
      let factorId = event.moved.element.id
      if (newIndex > oldIndex) {
        this.lifestyleViewpointFactorsList
            .filter(vf => vf && vf.numWeightingDots && vf.numWeightingDots <= newIndex && vf.numWeightingDots > oldIndex)
            .forEach(vf => vf.numWeightingDots = (vf.numWeightingDots || 0) - 1)
      } else if (oldIndex > newIndex) {
        this.lifestyleViewpointFactorsList
            .filter(vf => vf && vf.numWeightingDots && vf.numWeightingDots >= newIndex && vf.numWeightingDots < oldIndex)
            .forEach(vf => vf.numWeightingDots = (vf.numWeightingDots || 0) + 1)
      }
      this.viewpointFactors[factorId].numWeightingDots = newIndex
      this.reallocateWeights();

      this.initiateSync()
    }
  }

  initiateSync() {
    if (!this.updateSync) {
      this.updateSync = setTimeout(() => this.updateFactors(), 1000);
    }
  }


  async updateFactors() {
    this.updatingFactors = true;
    this.updateSync = null;
    await getModule(ViewpointsModule).putViewpointFactors(Object.values(this.viewpointFactors))
    this.updatingFactors = false;
  }


}

